import { Directive, effect, inject, ElementRef, Renderer2 } from '@angular/core';
import { BreadcrumbService } from './breadcrumb.service';
import { BreadcrumbsComponent } from './breadcrumbs.component';

@Directive({
  selector: '[appAutoBreadcrumbs]',
  standalone: false
})
export class AutoBreadcrumbsDirective {
  private breadcrumbService = inject(BreadcrumbService);
  private breadcrumbsComponent = inject(BreadcrumbsComponent);
  private elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  constructor() {
    // Add the auto-breadcrumbs class for styling
    this.renderer.addClass(this.elementRef.nativeElement, 'auto-breadcrumbs');

    // Use effect to automatically update when breadcrumbs signal changes
    effect(() => {
      const breadcrumbs = this.breadcrumbService.breadcrumbs();
      this.breadcrumbsComponent.links = breadcrumbs;
      
      // Add/remove hide-breadcrumb class based on whether breadcrumbs are empty
      if (breadcrumbs.length === 0) {
        this.renderer.addClass(this.elementRef.nativeElement, 'hide-breadcrumb');
      } else {
        this.renderer.removeClass(this.elementRef.nativeElement, 'hide-breadcrumb');
      }
    });
  }
}
